<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <!-- Year Filter Dropdown -->
        <div class="row mb-4">
          <div class="col-lg-12">
            <div class="card">
              <div class="p-3 card-body">
                <div class="row align-items-center">
                  <div class="col-md-3">
                    <label class="form-label font-weight-bold">Filter Tahun:</label>
                    <select 
                      v-model="selectedYear" 
                      @change="fetchDashboardData" 
                      class="form-control"
                    >
                      <option 
                        v-for="year in availableYears" 
                        :key="year" 
                        :value="year"
                      >
                        {{ year }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4" v-if="canAccessDashboard">
          <div class="col-lg-12">
            <div class="card">
              <div class="p-3 card-body">
                <p class="mb-2 font-weight-bold">Download Data Warga PDF</p>
                <div class="row align-items-end">
                  <div class="col-md-3" v-if="isAdmin">
                    <label class="form-label">Filter Wilayah:</label>
                    <select v-model="pdfWilayah" class="form-control" @change="pdfSektor = ''">
                      <option value="">Semua Wilayah</option>
                      <option
                        v-for="w in dataJumlahWilayah"
                        :key="w.id"
                        :value="w.id"
                      >{{ w.wilayah }}</option>
                    </select>
                  </div>
                  <div class="col-md-3" v-if="isAdmin || isKetuaWilayah">
                    <label class="form-label">Filter Sektor:</label>
                    <select v-model="pdfSektor" class="form-control">
                      <option value="">Semua Sektor</option>
                      <option
                        v-for="s in filteredSektors"
                        :key="s.id"
                        :value="s.id"
                      >{{ s.nama }}</option>
                    </select>
                  </div>
                  <div class="col-md-6">
                    <button
                      class="btn btn-danger w-100"
                      @click="downloadDataWargaPdf"
                      :disabled="downloadingPdf"
                    >
                      <i class="ni ni-cloud-download-95 me-1"></i>
                      {{ downloadingPdf ? 'Mengunduh PDF...' : 'Download Data Warga PDF' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="row">
            <div class="col-lg-12">
              <div class="mb-4 card">
                <div class="p-3 card-body">
                  <div class="d-flex flex-row-reverse justify-content-between">
                    <div class="col-md-12">
                      <div class="numbers">
                        <p class="mb-3 text-lg text-uppercase font-weight-bold">
                          Data Jemaat
                        </p>
                        <div class="row">
                          <div class="col-md-6 col-lg-4">
                            <card
                              title="Jumlah Jemaat"
                              :value="dataJemaatAktif + dataJemaatTidakAktif"
                              directionReverse
                            ></card>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <card
                              title="Jumlah Jemaat Aktif"
                              :value="dataJemaatAktif"
                              directionReverse
                            ></card>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <card
                              title="Jumlah Jemaat Tidak Aktif"
                              :value="dataJemaatTidakAktif"
                              directionReverse
                            ></card>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <card
                              title="Jumlah Laki-Laki"
                              :value="dataJemaatL"
                              directionReverse
                            ></card>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <card
                              title="Jumlah Perempuan"
                              :value="dataJemaatP"
                              directionReverse
                            ></card>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <card
                              title="Jumlah Keluarga"
                              :value="dataKKAktif + dataKKTidakAktif"
                              directionReverse
                            ></card>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <card
                              title="Jumlah Keluarga Aktif"
                              :value="dataKKAktif"
                              directionReverse
                            ></card>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <card
                              title="Jumlah Keluarga Tidak Aktif"
                              :value="dataKKTidakAktif"
                              directionReverse
                            ></card>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <card
                              title="Jumlah Titipan"
                              :value="dataTitipan"
                              directionReverse
                            ></card>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <card
                              title="Jumlah Disabilitas"
                              :value="dataDisabilitas"
                              directionReverse
                            ></card>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <card
                              title="Pindahan Ke Kristen"
                              :value="dataPindahanKeKristen"
                              directionReverse
                            ></card>
                          </div>
                          <div class="col-md-6 col-lg-4">
                            <card
                              title="Pindahan Ke Non-Kristen"
                              :value="dataPindahanDariKristen"
                              directionReverse
                            ></card>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 mb-4">
            <!-- line chart -->
            <div class="card z-index-2">
              <consumption-by-room-chart
                :key="datas"
                :labels="labels"
                :colors="colors"
                :datas="datas"
                :title="title"
                id="chart-jumlah"
              />
            </div>
          </div>
          <div class="col-lg-12">
            <div class="card z-index-2">
              <consumption-by-room-chart
                :key="datas2"
                :labels="labels2"
                :colors="colors2"
                :datas="datas2"
                :title="title2"
                id="chart-persentase"
              />
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div class="col-md-12">
                    <div class="numbers">
                      <p class="mb-3 text-lg text-uppercase font-weight-bold">
                        Data Usia
                      </p>
                      <div class="row">
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia < 6"
                            :value="dataUmur06"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia 6 - < 12"
                            :value="dataUmur612"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia 12 - < 15"
                            :value="dataUmur1215"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia 15 - < 18"
                            :value="dataUmur1518"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia 18 - < 24"
                            :value="dataUmur1824"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia 24 - < 30"
                            :value="dataUmur2430"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia 30 - < 60"
                            :value="dataUmur3060"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia 60 - < 70"
                            :value="dataUmur6070"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia > 70"
                            :value="dataUmur70"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Anak (0-12)"
                            :value="dataUmurAnak"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Pra-Remaja (13-15)"
                            :value="dataUmurPraRemaja"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia Remaja (16-17)"
                            :value="dataUmurRemaja"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia Pemuda (18+)"
                            :value="dataPemuda"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Usia Belum Terisi"
                            :value="dataUmurKosong"
                            directionReverse
                          ></card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div class="col-md-12">
                    <div class="numbers">
                      <p class="mb-3 text-lg text-uppercase font-weight-bold">
                        Data Kaum Bapak / Ibu
                      </p>
                      <div class="row">
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Kaum Bapak"
                            :value="dataKaumBapak"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Kaum Ibu"
                            :value="dataKaumIbu"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Anak Laki-Laki"
                            :value="dataAnakL"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-3">
                          <card
                            title="Anak Perempuan"
                            :value="dataAnakP"
                            directionReverse
                          ></card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div class="col-md-12">
                    <div class="numbers">
                      <p class="mb-3 text-lg text-uppercase font-weight-bold">
                        Data KK
                      </p>
                      <div class="row">
                        <div class="col-lg-6">
                          <card
                            title="KK Tambah"
                            :value="dataKeluargaMasuk"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-lg-6">
                          <card
                            title="KK Keluar"
                            :value="dataKeluargaKeluar"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-lg-6">
                          <card
                            title="Anggota Lahir"
                            :value="dataLahirTahunIni"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-lg-6">
                          <card
                            title="Anggota Meninggal"
                            :value="dataMeninggalTahunIni"
                            directionReverse
                          ></card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="mb-4 card">
              <div class="p-3 card-body">
                <div class="d-flex flex-row-reverse justify-content-between">
                  <div class="col-md-12">
                    <div class="numbers">
                      <p class="mb-3 text-lg text-uppercase font-weight-bold">
                        Data Status Perkawinan
                      </p>
                      <div class="row">
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Duda"
                            :value="dataDuda"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Janda"
                            :value="dataJanda"
                            directionReverse
                          ></card>
                        </div>
                        <div class="col-md-6 col-lg-4">
                          <card
                            title="Hidup Sendiri"
                            :value="dataSendiri"
                            directionReverse
                          ></card>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="!isKetuaSektor">
          <div class="col-lg-12 mb-lg-0 mb-4" v-if="isAdmin">
            <bar-chart
              :key="datas3"
              :datas="datas3"
              :labels="labels3"
              :colors="colors3"
              title="Jumlah Jemaat Per Wilayah"
              id="chart-wilayah"
            />
          </div>
        </div>
        <div class="row mt-4" v-if="!isKetuaSektor">
          <div class="col-lg-12 mb-lg-0 mb-4">
            <bar-chart
              :key="datas4"
              :datas="datas4"
              :labels="labels4"
              :colors="colors4"
              title="Jumlah Jemaat Per Sektor"
              id="chart-sektor"
            />
          </div>
        </div>
        <div class="row mt-4" v-if="isAdmin">
          <div class="col-lg-12 mb-lg-0 mb-4">
            <bar-chart
              :key="datas5"
              :datas="datas5"
              :labels="labels5"
              :colors="colors5"
              title="Jumlah Keluarga Per Wilayah"
              id="chart-wilayah-keluarga"
            />
          </div>
        </div>
        <div class="row mt-4" v-if="!isKetuaSektor">
          <div class="col-lg-12 mb-lg-0 mb-4">
            <bar-chart
              :key="datas6"
              :datas="datas6"
              :labels="labels6"
              :colors="colors6"
              title="Jumlah Keluarga Per Sektor"
              id="chart-sektor-keluarga"
            />
          </div>
        </div>
      </div>
    </div>
    <auth-check></auth-check>
  </div>
</template>
<script>
import Card from "@/examples/Cards/Card.vue";
import ConsumptionByRoomChart from "@/examples/Charts/ConsumptionRoomChart.vue";
import BarChart from "../examples/Charts/BarChart.vue";
import AuthCheck from "@/components/authCheck.vue";

export default {
  name: "dashboard-default",
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    filteredSektors() {
      if (!this.dataJumlahSektor) return [];
      if (!this.pdfWilayah) return this.dataJumlahSektor;
      return this.dataJumlahSektor.filter(s => s.id_wilayah == this.pdfWilayah);
    },
    isKetuaWilayah() {
      return this.$store.getters.isKetuaWilayah;
    },
    isKetuaSektor() {
      return this.$store.getters.isKetuaSektor;
    },
    canAccessDashboard() {
      return this.$store.getters.isAdmin || this.$store.getters.isKetuaWilayah || this.$store.getters.isKetuaSektor;
    },
  },
  data() {
    return {
      downloadingPdf: false,
      pdfWilayah: '',
      pdfSektor: '',
      selectedYear: new Date().getFullYear(),
      availableYears: [],
      dataAnak: "",
      dataCucu: "",
      dataJemaat: "",
      dataJemaatAktif: "",
      dataJemaatTidakAktif: "",
      dataKKAktif: "",
      dataKKTidakAktif: "",
      dataTitipan: "",
      dataDisabilitas: "",
      dataPindahanDariKristen: "",
      dataPindahanKeKristen: "",
      dataJemaatL: "",
      dataJemaatP: "",
      dataJumlahSektor: "",
      dataJumlahWilayah: "",
      dataJumlahKeluargaSektor: "",
      dataBaptisDewasa: "",
      dataJumlahKeluargaWilayah: "",
      dataUmur: "",
      dataKK: "",
      dataKeluarga: "",
      dataLainnya: "",
      dataMenantu: "",
      dataOrangTua: "",
      dataPasangan: "",
      dataSaudara: "",
      dataSektor: "",
      dataKeluargaKeluar: "",
      dataKeluargaMasuk: "",
      dataLahirTahunIni: "",
      dataMeninggalTahunIni: "",
      dataUltah: "",
      dataWilayah: "",
      dataUmur06: "",
      dataUmur612: "",
      dataUmur1215: "",
      dataUmur1518: "",
      dataUmur1824: "",
      dataUmur2430: "",
      dataUmur3060: "",
      dataUmur6070: "",
      dataUmur70: "",
      dataUmurAnak: "",
      dataUmurPraRemaja: "",
      dataUmurRemaja: "",
      dataUmurPemuda: "",
      dataKaumBapak: "",
      dataKaumIbu: "",
      dataDuda: "",
      dataJanda: "",
      dataSendiri: "",
      dataUmurKosong: "",
      dataAnakL: "",
      dataAnakP: "",
      kosong: "",
      terisi: "",
      labels: [],
      datas: [],
      colors: [],
      title: "",
      labels2: [],
      datas2: [],
      colors2: [],
      title2: "",
      labels3: [],
      datas3: [],
      colors3: [],
      labels4: [],
      datas4: [],
      colors4: [],
      labels5: [],
      datas5: [],
      colors5: [],
      labels6: [],
      datas6: [],
      colors6: [],
    };
  },
  methods: {
    async downloadDataWargaPdf() {
      this.downloadingPdf = true;
      try {
        const params = {};
        const user = this.$store.state.user;
        if (user && user.role === 3) {
          // Ketua Sektor: force sektor, no other params
          params.sektor = user.sektor_id;
        } else if (user && user.role === 2) {
          // Ketua Wilayah: force wilayah, allow sektor selection within their wilayah
          params.wilayah = user.wilayah_id;
          if (this.pdfSektor) params.sektor = this.pdfSektor;
        } else {
          // Admin: use dropdowns as-is
          if (this.pdfSektor) params.sektor = this.pdfSektor;
          else if (this.pdfWilayah) params.wilayah = this.pdfWilayah;
        }

        const response = await this.axios.get(
          process.env.VUE_APP_API_URL + "laporan/data-warga-pdf",
          {
            responseType: "blob",
            params: params,
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Data_Warga_JKK.pdf");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading PDF:", error);
        alert("Gagal mengunduh PDF. Silakan coba lagi.");
      } finally {
        this.downloadingPdf = false;
      }
    },
    /**
     * Generate random color for charts
     */
    randomColor() {
      const r = () => Math.floor(256 * Math.random());
      return `rgb(${r()}, ${r()}, ${r()})`;
    },
    
    /**
     * Initialize available years (current year down to 5 years below)
     */
    initializeYears() {
      const currentYear = new Date().getFullYear();
      this.availableYears = [];
      for (let i = 0; i <= 5; i++) {
        this.availableYears.push(currentYear - i);
      }
    },
    
    /**
     * Fetch dashboard data with selected year parameter
     */
    fetchDashboardData() {
      const params = this.selectedYear ? { year: this.selectedYear } : {};
      
      this.axios
        .get(process.env.VUE_APP_API_URL + "dashboard", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
          params: params
        })
        .then((resp) => {
          this.processResponseData(resp);
        })
        .catch((error) => {
          console.error("Error fetching dashboard data:", error);
        });
    },
    
    /**
     * Process the response data and update component properties
     */
    processResponseData(resp) {
      this.dataJemaat = resp.data.data.dataJemaat;
      this.dataJemaatAktif = resp.data.data.dataJemaatAktif;
      this.dataJemaatTidakAktif = resp.data.data.dataJemaatTidakAktif;
      this.dataJemaatL = resp.data.data.dataJemaatL;
      this.dataJemaatP = resp.data.data.dataJemaatP;
      this.dataKK = resp.data.data.dataKK;
      this.dataKKAktif = resp.data.data.dataKKAktif;
      this.dataKKTidakAktif = resp.data.data.dataKKTidakAktif;

      this.colors = [
        "#d0a254",
        "#14656d",
        "#474afd",
        "#632cb5",
        "#922544",
        "#0c2b45",
        "#f2c403",
        "#54a89b",
      ];
      this.labels = [
        "Kepala Keluarga",
        "Pasangan",
        "Anak",
        "Saudara",
        "Orang Tua",
        "Menantu",
        "Cucu",
        "Lainnya",
      ];
      this.title = "Jumlah Per Peran";
      this.datas = [
        resp.data.data.dataKK,
        resp.data.data.dataPasangan,
        resp.data.data.dataAnak,
        resp.data.data.dataSaudara,
        resp.data.data.dataOrangTua,
        resp.data.data.dataMenantu,
        resp.data.data.dataCucu,
        resp.data.data.dataLainnya,
      ];
      this.colors2 = ["#FF0000", "#00FF00"];
      this.labels2 = ["Belum Terisi", "Terisi"];
      this.title2 = "Persentase Data";
      this.datas2 = [resp.data.data.kosong, resp.data.data.terisi];

      this.dataJumlahWilayah = Object.values(
        resp.data.data.dataJumlahWilayah
      );
      this.datas3 = Array();
      this.labels3 = Array();
      this.colors3 = Array();
      for (var element of this.dataJumlahWilayah) {
        this.colors3.push(this.randomColor());
        this.labels3.push(element.wilayah);
        this.datas3.push(element.TOTAL);
      }

      this.colors3.push(this.randomColor());
      this.labels3.push("Belum Terisi");
      this.datas3.push(resp.data.data.dataJumlahWilayahKosong);

      this.dataJumlahSektor = resp.data.data.dataJumlahSektor;
      this.datas4 = Array();
      this.labels4 = Array();
      this.colors4 = Array();
      const user = this.$store.state.user;
      const sektorList = (user && user.role === 2)
        ? this.dataJumlahSektor.filter(s => s.id_wilayah == user.wilayah_id)
        : this.dataJumlahSektor;
      for (var element2 of sektorList) {
        this.colors4.push(this.randomColor());
        this.labels4.push(element2.nama);
        this.datas4.push(element2.TOTAL);
      }

      this.colors4.push(this.randomColor());
      this.labels4.push("Belum Terisi");
      this.datas4.push(resp.data.data.dataJumlahSektorKosong);

      this.dataJumlahKeluargaWilayah =
        resp.data.data.dataJumlahKeluargaWilayah;
      this.datas5 = Array();
      this.labels5 = Array();
      this.colors5 = Array();
      for (var element3 of this.dataJumlahKeluargaWilayah) {
        this.colors5.push(this.randomColor());
        this.labels5.push(element3.wilayah);
        this.datas5.push(element3.TOTAL);
      }

      this.colors5.push(this.randomColor());
      this.labels5.push("Belum Terisi");
      this.datas5.push(resp.data.data.dataJumlahKeluargaWilayahKosong);

      this.dataJumlahKeluargaSektor =
        resp.data.data.dataJumlahKeluargaSektor;
      this.datas6 = Array();
      this.labels6 = Array();
      this.colors6 = Array();
      const keluargaSektorList = (user && user.role === 2)
        ? this.dataJumlahKeluargaSektor.filter(s => s.id_wilayah == user.wilayah_id)
        : this.dataJumlahKeluargaSektor;
      for (var element4 of keluargaSektorList) {
        this.colors6.push(this.randomColor());
        this.labels6.push(element4.nama);
        this.datas6.push(element4.TOTAL);
      }

      this.colors6.push(this.randomColor());
      this.labels6.push("Belum Terisi");
      this.datas6.push(resp.data.data.dataJumlahKeluargaSektorKosong);

      this.dataTitipan = resp.data.data.dataTitipan;
      this.dataDisabilitas = resp.data.data.dataDisabilitas;
      this.dataPindahanDariKristen = resp.data.data.dataPindahanDariKristen;
      this.dataPindahanKeKristen = resp.data.data.dataPindahanKeKristen;
      this.dataUmur = resp.data.data.dataUmur;
      this.dataUmur06 = resp.data.data.dataUmur["0-5"] || 0;
      this.dataUmur612 = resp.data.data.dataUmur["6-11"] || 0;
      this.dataUmur1215 = resp.data.data.dataUmur["12-14"] || 0;
      this.dataUmur1518 = resp.data.data.dataUmur["15-17"] || 0;
      this.dataUmur1824 = resp.data.data.dataUmur["18-23"] || 0;
      this.dataUmur2430 = resp.data.data.dataUmur["24-29"] || 0;
      this.dataUmur3060 = resp.data.data.dataUmur["30-59"] || 0;
      this.dataUmur6070 = resp.data.data.dataUmur["60-69"] || 0;
      this.dataUmur70 = resp.data.data.dataUmur["70+"] || 0;
      this.dataUmurAnak = resp.data.data.dataKlasifikasi["0-12"] || 0;
      this.dataUmurPraRemaja = resp.data.data.dataKlasifikasi["13-15"] || 0;
      this.dataUmurRemaja = resp.data.data.dataKlasifikasi["16-17"] || 0;
      this.dataPemuda = resp.data.data.dataKlasifikasi["18+"] || 0;
      this.dataUmurKosong = resp.data.data.dataUmur[""] || 0;
      this.dataKaumBapak = resp.data.data.dataKaumBapak;
      this.dataKaumIbu = resp.data.data.dataKaumIbu;
      this.dataAnakL = resp.data.data.dataAnakL;
      this.dataAnakP = resp.data.data.dataAnakP;
      this.dataKeluarga = resp.data.data.dataKeluarga;
      this.dataLainnya = resp.data.data.dataLainnya;
      this.dataMenantu = resp.data.data.dataMenantu;
      this.dataOrangTua = resp.data.data.dataOrangTua;
      this.dataPasangan = resp.data.data.dataPasangan;
      this.dataSaudara = resp.data.data.dataSaudara;
      this.dataSektor = resp.data.data.dataSektor;
      this.dataWilayah = resp.data.data.dataWilayah;
      this.dataUltah = resp.data.data.dataUltah;
      this.dataKeluargaKeluar = resp.data.data.dataKeluargaKeluar;
      this.dataKeluargaMasuk = resp.data.data.dataKeluargaMasuk;
      this.dataLahirTahunIni = resp.data.data.dataLahirTahunIni;
      this.dataMeninggalTahunIni = resp.data.data.dataMeninggalTahunIni;
      this.dataDuda = resp.data.data.dataDuda;
      this.dataJanda = resp.data.data.dataJanda;
      this.dataSendiri = resp.data.data.dataSendiri;
      this.dataAnak = resp.data.data.dataAnak;
      this.dataCucu = resp.data.data.dataCucu;
      this.kosong = resp.data.data.kosong;
      this.terisi = resp.data.data.terisi;
    }
  },
  created() {
    this.initializeYears();
    this.fetchDashboardData();
  },
  components: {
    Card,
    ConsumptionByRoomChart,
    BarChart,
    AuthCheck,
  },
};
</script>
